import { render, staticRenderFns } from "./SoilDetails.vue?vue&type=template&id=00d9b1d1&scoped=true&lang=html&"
import script from "./SoilDetails.vue?vue&type=script&lang=js&"
export * from "./SoilDetails.vue?vue&type=script&lang=js&"
import style0 from "./SoilDetails.vue?vue&type=style&index=0&id=00d9b1d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d9b1d1",
  null
  
)

export default component.exports